import React from 'react'
import { useCommunity } from '~/contexts/CommunityContext'
import { GetCommunitySettingsDocument } from '~/api/generated/graphql'
import { useAuth } from '~/auth/Auth'
import { usePermissions } from '~/pages/posts/PostUtils'
import '@css/common/AuthoringArea.scss'
import '@css/pages/community/CommunitySettings.scss'
import { useNavigate } from 'react-router'
import CommunitySettingsEdit from '~/pages/community/CommunitySettingsEdit'
import { CommunitySettingsDataModel } from '~/types'
import { useQuery } from '@apollo/client'

const CommunitySettings = () => {
  const navigate = useNavigate()
  const { loading: loadingAuth, authUserId, actingSysAdmin, profileVisible } = useAuth()
  const { loading: loadingPermissions, hasLeaderPermissions } = usePermissions(authUserId)
  const { communityId } = useCommunity()
  const { loading: loadingCommunity, data } = useQuery(GetCommunitySettingsDocument, {
    variables: { id: communityId ?? '' },
    skip: !communityId,
  })

  if (!loadingAuth && !loadingPermissions && !(actingSysAdmin || hasLeaderPermissions)) {
    void navigate('../about}')
  }

  if (loadingCommunity || loadingAuth || loadingPermissions || !data?.community?.communityId) return <>Loading...</>

  const community: CommunitySettingsDataModel = {
    communityId: data.community.communityId,
    name: data.community.name,
    description: data.community.description ?? null,
    photo: data.community.photo ?? null,
    aliases: (data.community.aliases as string[]) ?? [],
    type: data.community.type,
  }

  return <CommunitySettingsEdit community={community} isLeader={hasLeaderPermissions} profileVisible={profileVisible} />
}

export default CommunitySettings
